// Notas de entrada (BDM-1050).

export const LINK_OPTIONS = [
    { label: 'Todas', value: '' },
    { label: 'Sem compra vinculada', value: 'unlinked' },
    { label: 'Vinculadas a uma compra', value: 'linked' },
];

export const PAYMENT_OPTIONS = [
    { label: 'Todas', value: '' },
    { label: 'Sem conta a pagar', value: 'without' },
    { label: 'Com conta a pagar', value: 'with' },
];

export const getInvoiceLabel = invoice =>
    invoice?.series ? `${invoice.number}/${invoice.series}` : (invoice?.number ?? '—');

/**
 * Quanto da compra já está coberto por notas. `over` é o caso comum de frete e
 * IPI que vêm na nota e não estavam no custo do pedido — vira aviso, nunca
 * bloqueio.
 */
export const getInvoicedSummary = purchaseOrder => {
    const total = purchaseOrder?.total ?? 0;
    const invoiced = purchaseOrder?.invoiced_amount ?? 0;

    return {
        total,
        invoiced,
        percent: total > 0 ? Math.min(100, Math.round((invoiced / total) * 100)) : 0,
        difference: invoiced - total,
        over: total > 0 && invoiced > total,
        partial: invoiced > 0 && invoiced < total,
        covered: total > 0 && invoiced >= total,
    };
};
